module.exports = __webpack_public_path__ + "media/images/pear_2-a6af3084a174c8ccdbc9ce788fb67c90.jpg";